export const CUMUL_STOCK_VAR_PERIODS = {
  year_current: {
    key: "year_current",
    label: "Année en cours",
    description: "Du 1er janvier au 31 décembre",
    debut: "Date(1,1,bul.annee)",
    fin: "Date(31,12,bul.annee)",
  },
  year_previous: {
    key: "year_previous",
    label: "Année précédente",
    description: "Du 1er janvier au 31 décembre de l'année précédente",
    debut: "Date(1,1,bul.annee-1)",
    fin: "Date(31,12,bul.annee-1)",
  },
  quarter_1: {
    key: "quarter_1",
    label: "1er trimestre",
    description: "Janvier à Mars",
    debut: "Date(1,1,bul.annee)",
    fin: "Date(31,3,bul.annee)",
  },
  quarter_2: {
    key: "quarter_2",
    label: "2ème trimestre",
    description: "Avril à Juin",
    debut: "Date(1,4,bul.annee)",
    fin: "Date(30,6,bul.annee)",
  },
  quarter_3: {
    key: "quarter_3",
    label: "3ème trimestre",
    description: "Juillet à Septembre",
    debut: "Date(1,7,bul.annee)",
    fin: "Date(30,9,bul.annee)",
  },
  quarter_4: {
    key: "quarter_4",
    label: "4ème trimestre",
    description: "Octobre à Décembre",
    debut: "Date(1,10,bul.annee)",
    fin: "Date(31,12,bul.annee)",
  },
  custom: {
    key: "custom",
    label: "Période personnalisée",
    description: "Définir manuellement les dates de début et fin",
    debut: "",
    fin: "",
  },
};

export const CUMUL_BULLETINS_PERIODS = {
  year_current: {
    key: "year_current",
    label: "Année en cours",
    description: "Du 1er janvier au 31 décembre",
    debut: "Date(1,1,bul.annee)",
    fin: "Date(31,12,bul.annee)",
  },
  year_previous: {
    key: "year_previous",
    label: "Année précédente",
    description: "Du 1er janvier au 31 décembre de l'année précédente",
    debut: "Date(1,1,bul.annee-1)",
    fin: "Date(31,12,bul.annee-1)",
  },
  quarter_1: {
    key: "quarter_1",
    label: "1er trimestre",
    description: "Janvier à Mars",
    debut: "Date(1,1,bul.annee)",
    fin: "Date(31,3,bul.annee)",
  },
  quarter_2: {
    key: "quarter_2",
    label: "2ème trimestre",
    description: "Avril à Juin",
    debut: "Date(1,4,bul.annee)",
    fin: "Date(30,6,bul.annee)",
  },
  quarter_3: {
    key: "quarter_3",
    label: "3ème trimestre",
    description: "Juillet à Septembre",
    debut: "Date(1,7,bul.annee)",
    fin: "Date(30,9,bul.annee)",
  },
  quarter_4: {
    key: "quarter_4",
    label: "4ème trimestre",
    description: "Octobre à Décembre",
    debut: "Date(1,10,bul.annee)",
    fin: "Date(31,12,bul.annee)",
  },
  custom: {
    key: "custom",
    label: "Période personnalisée",
    description: "Définir manuellement les dates de début et fin",
    debut: "",
    fin: "",
  },
};
